import * as React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const communities = [{
  title: "An Insider's Guide to Cloud Computing",
  description: "A comprehensive look at the realities of cloud migration and the strategic shifts required for enterprise success.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/insiders_guide_cloud_computing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/insiders_guide_cloud_computing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/insiders_guide_cloud_computing.png-wvc-sizes",
  linkText: "View on Amazon",
  linkTo: "https://www.amazon.com/stores/author/B001IU4QAQ"
}, {
  title: "Cloud Computing and SOA Convergence in Your Enterprise",
  description: "The foundational guide to integrating Service-Oriented Architecture with cloud computing strategies.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_soa_convergence.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_soa_convergence.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_soa_convergence.png-wvc-sizes",
  linkText: "View on Amazon",
  linkTo: "https://www.amazon.com/Cloud-Computing-Convergence-Enterprise-Step/dp/0136009220"
}, {
  title: "Enterprise Application Integration",
  description: "A seminal work on the methodologies and technologies behind seamless enterprise-level data and application integration.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/enterprise_app_integration.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/enterprise_app_integration.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/enterprise_app_integration.png-wvc-sizes",
  linkText: "View on Amazon",
  linkTo: "https://www.amazon.com/Enterprise-Application-Integration-David-Linthicum/dp/0201615835"
}, {
  title: "B2B Application Integration",
  description: "Strategies and business models for modernizing e-commerce through robust business-to-business integration.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/b2b_app_integration.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/b2b_app_integration.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/b2b_app_integration.png-wvc-sizes",
  linkText: "View on Amazon",
  linkTo: "https://www.amazon.com/B2B-Application-Integration-Business-Enable-Enterprise/dp/0201709368"
}, {
  title: "Next Generation Application Integration",
  description: "Exploring the evolution of middleware and the future of distributed computing architectures.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/next_gen_app_integration.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/next_gen_app_integration.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/next_gen_app_integration.png-wvc-sizes",
  linkText: "View on Amazon",
  linkTo: "https://www.amazon.com/Next-Generation-Application-Integration-Information/dp/0201844567"
}, {
  title: "David Linthicum's Guide to Client/Server and Intranet Development",
  description: "A practical technical guide to managing and architecting distributed database systems.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/client_server_databases.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/client_server_databases.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/client_server_databases.png-wvc-sizes",
  linkText: "View on Amazon",
  linkTo: "https://www.amazon.com/Linthicums-Client-Server-Intranet-Development/dp/047117467X"
}, {
  title: "12 Steps To SOA",
  description: "The definitive guide to architecting scalable enterprise systems and cloud modernization.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_computing_strategy.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_computing_strategy.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_computing_strategy.png-wvc-sizes",
  linkText: "View on Amazon",
  linkTo: "https://www.amazon.com/Books-David-S-Linthicum/s?rh=n%3A283155%2Cp_27%3ADavid%2BS.%2BLinthicum"
}, {
  title: "Using Turbo C++",
  description: "Insights into the intersection of AI, Edge computing, and the next decade of technological innovation.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/future_of_computing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/future_of_computing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/future_of_computing.png-wvc-sizes",
  linkText: "View on Amazon",
  linkTo: "https://www.amazon.com/Books-David-S-Linthicum/s?rh=n%3A283155%2Cp_27%3ADavid%2BS.%2BLinthicum"
}, {
  title: "Full Contact Cloud Computing: A Step-By-Step Guide For Transitioning Your Enterprise to the Cloud",
  description: "A strategic roadmap for leveraging cloud-native architectures to drive business agility and innovation.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/unlocking_cloud_power.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/unlocking_cloud_power.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/unlocking_cloud_power.png-wvc-sizes",
  linkText: "View on Amazon",
  linkTo: "https://www.amazon.com/Books-David-S-Linthicum/s?rh=n%3A283155%2Cp_27%3ADavid%2BS.%2BLinthicum"
}, {
  title: "Unlocking the Power of the Cloud: Governance, Artificial Intelligence, Risk Management, Value",
  description: "A strategic roadmap for leveraging cloud-native architectures to drive business agility and innovation.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/unlocking_cloud_power_new.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/unlocking_cloud_power_new.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/unlocking_cloud_power_new.png-wvc-sizes",
  linkText: "View on Amazon",
  linkTo: "https://www.amazon.com/stores/author/B001IU4QAQ"
}];
export default function PublishedWorks() {
  return <section data-section-id="225197" id="published-works" className="bg-background text-foreground py-24">
      <div className="mx-auto max-w-7xl px-8">
        <h2 className="font-default mb-12 text-center text-3xl font-extrabold tracking-tighter md:text-4xl lg:text-5xl text-foreground">
          Published Works & Thought Leadership
        </h2>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {communities.map((item, i) => <Card key={i} data-index={i} className="flex h-full flex-col overflow-hidden rounded-md border border-border bg-card/50 backdrop-blur-xl text-card-foreground shadow-xl transition-transform duration-300 hover:-translate-y-2 hover:rotate-1">
              <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.title} loading="lazy" decoding="async" className="h-64 w-full object-contain bg-muted/20 p-4 opacity-90 transition-all duration-500 hover:opacity-100" />
              <CardContent className="flex-grow p-6">
                <CardTitle className="font-default mb-3 text-xl font-bold text-primary tracking-tight">
                  {item.title}
                </CardTitle>
                <CardDescription className="font-sans text-sm text-muted-foreground leading-relaxed">
                  {item.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="mt-auto px-6 pb-6 pt-0">
                <Link to={item.linkTo} newTab className="group inline-flex items-center text-xs font-mono font-medium uppercase tracking-widest text-secondary hover:text-primary transition-colors">
                  {item.linkText}
                  <ChevronRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}